export enum HorizontalAlignmentStyle {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
}
